import BaseNMComAdapter from "adapters/base.nmcom.adapter";

export default class ServiceRequestAdapter extends BaseNMComAdapter {
	static standardizeOptions(object, options = {}) {
		options['baseUrl'] = options['baseUrl'] || "<%=serviceRequestApiBaseUrl%>";
		return super.standardizeOptions(object, options)
	}
}
